module.exports = __webpack_public_path__ + "static/img/伙伴客户-美胸汇.35bb9850.png";